export const API_BASE_URL = 'https://senasa-worker.jlvas.workers.dev';
export const LOCAL_STORAGE_TOKEN_KEY = 'auth_token'; 